const READY_EVENT = 'rpso:route-metadata-ready';

/** Просмотр отправляется после метаданных: каталог обновляет их асинхронно. */
export const notifyRouteMetadataReady = (pathname: string): void => {
  document.documentElement.dataset.metadataPath = pathname;
  document.dispatchEvent(new Event(READY_EVENT));
};

export const isRouteMetadataReady = (pathname: string): boolean =>
  document.documentElement.dataset.metadataPath === pathname;

export const subscribeRouteMetadata = (notify: () => void): (() => void) => {
  document.addEventListener(READY_EVENT, notify);
  return () => document.removeEventListener(READY_EVENT, notify);
};
